import React from 'react'
import Navbar from '../Components/Navbar/Navbar'
import FooterMini from '../Components/FooterMini/FooterMini'

const LayoutTwo = ({ children }) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      {/* Navbar component */}
      <Navbar />
      {/* Content area for child components */}
      {children}
      {/* FooterMini component */}
      <FooterMini />
    </div>
  )
}

export default LayoutTwo